<div class="modal-hero" [class.closing]="isClosing" (click)="onOverlayClick($event)">
  <div [class.open]="isOpen" [class.closing]="isClosing" class="modal-inner bg-white dark:bg-gray-950 text-black dark:text-white" [class]="modalInnerClasses"
    [style.max-width]="maxWidthValue" [style.max-height]="maxHeightValue" [style.height]="height" [style.width]="width">

    <!-- inner ng-content project - overrides all content of the modal incl. header, body & footer -->
    <div class="inner-custom" #ref>
      <ng-content #ref select="[inner]"></ng-content>
    </div>

    @if (!ref.children.length) {
      <!-- header -->
      <div class="modal-header flex" [class]="modalHeaderClasses">
        <div class="title">
          <ng-content select="[header]"></ng-content>
        </div>
        <!-- close button -->
        @if (closeable) {
          <app-icon height="h-3" width="w-3" class="cursor-pointer text-gray-400" [icon]="icons.cross" (click)="close()"></app-icon>
        }
      </div>
      <!-- body -->
      <div class="modal-body" [class]="modalBodyClasses" [class.p-0]="removeBodyPadding">
        @if (!loadingValue) {
          <!-- content projection for the body -->
          <ng-content select="[body]"></ng-content>
        } @else {
          <app-loader-small></app-loader-small>
        }
      </div>
      <!-- footer -->
      <div class="modal-footer border-white dark:border-gray-850">
        <ng-content select="[footer]"></ng-content>
      </div>
    }
  </div>
</div>
